import { Instagram, Music2, Linkedin } from 'lucide-react';
interface WinBackEmailProps {
  userName?: string;
}
const WinBackEmail = ({
  userName = 'Voyager'
}: WinBackEmailProps) => {
  return <>
    <style>{`
      @media (max-width: 640px) {
        .email-container { padding: 24px 12px !important; }
        .email-logo { width: 180px !important; }
        .email-heading { font-size: 24px !important; }
        .email-text { font-size: 14px !important; line-height: 22px !important; }
        .email-offer-box { padding: 24px 16px !important; }
        .email-emoji { font-size: 48px !important; margin-bottom: 12px !important; }
        .email-offer-title { font-size: 22px !important; }
        .email-offer-discount { font-size: 18px !important; }
        .email-button { padding: 12px 20px !important; font-size: 14px !important; }
        .email-social-icon { width: 24px !important; height: 24px !important; }
        .boost-grid { grid-template-columns: 1fr !important; gap: 12px !important; }
        .boost-column { padding: 12px !important; }
        .boost-item { padding: 8px !important; margin-bottom: 6px !important; }
        .boost-tier-title { font-size: 12px !important; }
        .boost-price { font-size: 14px !important; }
      }
    `}</style>
    <div style={{
    backgroundColor: '#f0fafa',
    minHeight: '100vh',
    padding: '40px 20px',
    fontFamily: "'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"
  }}>
      <div className="email-container" style={{
      backgroundColor: '#ffffff',
      margin: '0 auto',
      padding: '40px 20px',
      borderRadius: '8px',
      maxWidth: '600px'
    }}>
        <div style={{
        textAlign: 'center',
        marginBottom: '0'
      }}>
          <img src="/lovable-uploads/odyvoy-logo.png" alt="OdyVoy Logo" className="email-logo" style={{
          width: '250px',
          height: 'auto',
          margin: '0 auto'
        }} />
        </div>
        <h1 className="email-heading" style={{
        color: '#1a9a9a',
        fontSize: '32px',
        fontWeight: 'bold',
        margin: '8px 0 24px',
        padding: '0',
        textAlign: 'center'
      }}>
          We Miss You, {userName}! 💙
        </h1>
        
        <p className="email-text" style={{
        color: '#333',
        fontSize: '16px',
        lineHeight: '24px',
        margin: '16px 0'
      }}>
          Hi {userName},
        </p>
        
        <p className="email-text" style={{
        color: '#333',
        fontSize: '16px',
        lineHeight: '24px',
        margin: '16px 0'
      }}>
          We noticed your subscription recently ended, and we wanted to reach out. We hope you had amazing travel experiences with OdyVoy, and we'd love to have you back!
        </p>

        <div className="email-offer-box" style={{
        background: 'linear-gradient(135deg, #1a9a9a, #6dd4d4)',
        borderRadius: '8px',
        padding: '32px 24px',
        margin: '32px 0',
        textAlign: 'center'
      }}>
          <span className="email-emoji" style={{
          fontSize: '64px',
          display: 'block',
          marginBottom: '16px'
        }}>🎁</span>
          <h2 className="email-offer-title" style={{
          color: '#ffffff',
          fontSize: '28px',
          fontWeight: 'bold',
          margin: '0 0 16px',
          padding: '0'
        }}>
            Welcome Back Offer
          </h2>
          <p className="email-offer-discount" style={{
          color: '#ffffff',
          fontSize: '20px',
          fontWeight: 'bold',
          margin: '0 0 24px'
        }}>
            Get 10% Off Your Next Subscription
          </p>
          <p className="email-text" style={{
          color: '#ffffff',
          fontSize: '16px',
          lineHeight: '24px',
          margin: '0 0 24px'
        }}>Use code <strong style={{
            backgroundColor: 'rgba(255,255,255,0.2)',
            padding: '4px 12px',
            borderRadius: '4px',
            fontSize: '18px'
          }}>ODYVOY-TRAVEL-AGAIN-10</strong> at checkout
          </p>
          
          <a href="/pricing" className="email-button" style={{
          backgroundColor: '#f0d763',
          borderRadius: '6px',
          color: '#1a9a9a',
          fontSize: '16px',
          fontWeight: 'bold',
          textDecoration: 'none',
          textAlign: 'center',
          display: 'inline-block',
          padding: '14px 32px',
          margin: '0'
        }}>
            Claim Your 10% Discount
          </a>
        </div>

        <div style={{
        margin: '32px 0'
      }}>
          <h3 style={{
          color: '#1a9a9a',
          fontSize: '20px',
          fontWeight: 'bold',
          margin: '0 0 16px',
          textAlign: 'center'
        }}>
            Not Ready to Commit? Try a Boost Pass
          </h3>
          
          <div className="boost-grid" style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '12px',
          marginBottom: '20px'
        }}>
            {/* Premium Economy Column */}
            <div className="boost-column" style={{
            backgroundColor: '#f0fafa',
            padding: '16px',
            borderRadius: '8px',
            border: '2px solid #1a9a9a'
          }}>
              <h4 className="boost-tier-title" style={{
              color: '#1a9a9a',
              fontSize: '14px',
              fontWeight: 'bold',
              margin: '0 0 12px',
              textAlign: 'center'
            }}>
                Premium Economy
              </h4>
              
              <div className="boost-item" style={{
              backgroundColor: '#ffffff',
              padding: '10px',
              borderRadius: '6px',
              marginBottom: '8px'
            }}>
                <p style={{
                color: '#333',
                fontSize: '14px',
                fontWeight: 'bold',
                margin: '0 0 2px'
              }}>
                  3-Day Pass
                </p>
                <p className="boost-price" style={{
                color: '#1a9a9a',
                fontSize: '16px',
                fontWeight: 'bold',
                margin: '0'
              }}>
                  €3.49
                </p>
              </div>
              
              <div className="boost-item" style={{
              backgroundColor: '#ffffff',
              padding: '10px',
              borderRadius: '6px',
              marginBottom: '8px'
            }}>
                <p style={{
                color: '#333',
                fontSize: '14px',
                fontWeight: 'bold',
                margin: '0 0 2px'
              }}>
                  7-Day Pass
                </p>
                <p className="boost-price" style={{
                color: '#1a9a9a',
                fontSize: '16px',
                fontWeight: 'bold',
                margin: '0'
              }}>
                  €5.99
                </p>
              </div>
              
              <div className="boost-item" style={{
              backgroundColor: '#ffffff',
              padding: '10px',
              borderRadius: '6px'
            }}>
                <p style={{
                color: '#333',
                fontSize: '14px',
                fontWeight: 'bold',
                margin: '0 0 2px'
              }}>
                  14-Day Pass
                </p>
                <p className="boost-price" style={{
                color: '#1a9a9a',
                fontSize: '16px',
                fontWeight: 'bold',
                margin: '0'
              }}>
                  €9.99
                </p>
              </div>
            </div>
            
            {/* First Class Column */}
            <div className="boost-column" style={{
            backgroundColor: '#fff9e6',
            padding: '16px',
            borderRadius: '8px',
            border: '2px solid #f0d763'
          }}>
              <h4 className="boost-tier-title" style={{
              color: '#d4a800',
              fontSize: '14px',
              fontWeight: 'bold',
              margin: '0 0 12px',
              textAlign: 'center'
            }}>
                First Class
              </h4>
              
              <div className="boost-item" style={{
              backgroundColor: '#ffffff',
              padding: '10px',
              borderRadius: '6px',
              marginBottom: '8px'
            }}>
                <p style={{
                color: '#333',
                fontSize: '14px',
                fontWeight: 'bold',
                margin: '0 0 2px'
              }}>
                  3-Day Pass
                </p>
                <p className="boost-price" style={{
                color: '#d4a800',
                fontSize: '16px',
                fontWeight: 'bold',
                margin: '0'
              }}>
                  €5.99
                </p>
              </div>
              
              <div className="boost-item" style={{
              backgroundColor: '#ffffff',
              padding: '10px',
              borderRadius: '6px',
              marginBottom: '8px'
            }}>
                <p style={{
                color: '#333',
                fontSize: '14px',
                fontWeight: 'bold',
                margin: '0 0 2px'
              }}>
                  7-Day Pass
                </p>
                <p className="boost-price" style={{
                color: '#d4a800',
                fontSize: '16px',
                fontWeight: 'bold',
                margin: '0'
              }}>
                  €10.99
                </p>
              </div>
              
              <div className="boost-item" style={{
              backgroundColor: '#ffffff',
              padding: '10px',
              borderRadius: '6px'
            }}>
                <p style={{
                color: '#333',
                fontSize: '14px',
                fontWeight: 'bold',
                margin: '0 0 2px'
              }}>
                  14-Day Pass
                </p>
                <p className="boost-price" style={{
                color: '#d4a800',
                fontSize: '16px',
                fontWeight: 'bold',
                margin: '0'
              }}>
                  €16.99
                </p>
              </div>
            </div>
          </div>

          <a href="/pricing" style={{
          backgroundColor: 'transparent',
          border: '2px solid #1a9a9a',
          borderRadius: '6px',
          color: '#1a9a9a',
          fontSize: '16px',
          fontWeight: 'bold',
          textDecoration: 'none',
          textAlign: 'center',
          display: 'block',
          padding: '12px 24px',
          margin: '0'
        }}>
            Get a Boost Pass
          </a>
        </div>

        <hr style={{
        borderColor: '#e6e6e6',
        margin: '32px 0'
      }} />

        <div style={{
        backgroundColor: '#fff9e6',
        borderRadius: '8px',
        padding: '20px',
        margin: '24px 0'
      }}>
          <p style={{
          color: '#333',
          fontSize: '15px',
          lineHeight: '22px',
          margin: '0 0 12px'
        }}>
            <strong>Want to Tell Us Why You Left?</strong>
          </p>
          <p style={{
          color: '#666',
          fontSize: '14px',
          lineHeight: '20px',
          margin: '0'
        }}>
            Your feedback helps us improve. Reply to this email to share your thoughts, and we'll make sure our team hears you.
          </p>
        </div>

        <p style={{
        color: '#333',
        fontSize: '16px',
        lineHeight: '24px',
        margin: '24px 0 0'
      }}>
          Whether you choose to come back or not, we wish you incredible adventures ahead. Thank you for being part of the OdyVoy community.
        </p>

        <p style={{
        color: '#333',
        fontSize: '16px',
        lineHeight: '24px',
        marginTop: '32px'
      }}>
          Safe travels,
          <br />
          The OdyVoy Team 🌟
        </p>

        <hr style={{
        borderColor: '#e6e6e6',
        margin: '32px 0'
      }} />

        <div style={{
        textAlign: 'center',
        margin: '32px 0'
      }}>
          <p style={{
          color: '#333',
          fontSize: '16px',
          fontWeight: 'bold',
          marginBottom: '16px'
        }}>
            Stay Connected With Us
          </p>
          <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '20px',
          flexWrap: 'wrap',
          alignItems: 'center'
        }}>
            <a href="https://www.instagram.com/odyvoy_/" style={{
            textDecoration: 'none',
            color: '#64748b',
            transition: 'color 0.2s'
            }} aria-label="Follow us on Instagram">
              <Instagram className="email-social-icon" size={28} strokeWidth={1.5} />
            </a>
            <a href="https://www.tiktok.com/@odyvoy_" style={{
            textDecoration: 'none',
            color: '#64748b',
            transition: 'color 0.2s'
          }} aria-label="Follow us on TikTok">
              <Music2 className="email-social-icon" size={28} strokeWidth={1.5} />
            </a>
            <a href="https://www.linkedin.com/company/odyvoy/about/?viewAsMember=true" style={{
            textDecoration: 'none',
            color: '#64748b',
            transition: 'color 0.2s'
          }} aria-label="Follow us on LinkedIn">
              <Linkedin className="email-social-icon" size={28} strokeWidth={1.5} />
            </a>
          </div>
          
        </div>

        <div style={{
        textAlign: 'center',
        marginTop: '24px',
        paddingTop: '24px',
        borderTop: '1px solid #e6e6e6'
      }}>
          <p style={{
          color: '#8898aa',
          fontSize: '12px',
          lineHeight: '18px',
          margin: '8px 0'
        }}>
            <strong>OdyVoy</strong>
          </p>
          <p style={{
          color: '#8898aa',
          fontSize: '12px',
          lineHeight: '18px',
          margin: '8px 0'
        }}>Your AI-Powered Travel Companion</p>
          <p style={{
          color: '#8898aa',
          fontSize: '12px',
          lineHeight: '18px',
          margin: '16px 0'
        }}>
            <a href="/unsubscribe" style={{
            color: '#1a9a9a',
            textDecoration: 'underline'
          }}>Unsubscribe</a>
            {' | '}
            <a href="/privacy" style={{
            color: '#1a9a9a',
            textDecoration: 'underline'
          }}>Privacy Policy</a>
            {' | '}
            <a href="/terms" style={{
            color: '#1a9a9a',
            textDecoration: 'underline'
          }}>Terms of Service</a>
          </p>
          <p style={{
          color: '#8898aa',
          fontSize: '11px',
          lineHeight: '16px',
          margin: '16px 0'
        }}>
            © {new Date().getFullYear()} OdyVoy. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  </>;
};
export default WinBackEmail;